export default __webpack_public_path__ + "static/media/Group_mucap.0339f544.svg";